<template>
    <b-modal size="xl" centered hide-header hide-footer body-class="p-0" ref="draw-geofence" @shown="() => { initMap(); initDrawingInteraction(); }">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img src="@/assets/img/geofences.svg">
                <p class="text-light m-0 fs-4 ms-2">Dibujar Geocerca</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <b-form-group label="Tipo de Geocerca:" class="mb-2">
                <b-form-radio-group v-model="drawType" :options="options" button-variant="outline-primary" size="xl" name="radio-btn-outline" buttons aria-hidden="true"></b-form-radio-group>
            </b-form-group>
            <div id="geofence" class="d-flex border rounded">
            </div>
            <b-button variant="primary" class="mt-3" @click="saveDraw">Guardar</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import VectorService from '@/services/vector.service';
import geofencesModule from '@/store/modules/geofences.module';
import mapsModule from '@/store/modules/maps.module';
import GeofenceUtil from '@/utils/geofence.util';
import { Map, View } from 'ol';
import { defaults as defaultControls } from 'ol/control';
import { Circle, Polygon } from 'ol/geom';
import { Type } from 'ol/geom/Geometry';
import { Draw } from 'ol/interaction';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import { Fill, Stroke, Style } from 'ol/style';
import { Component, Vue, Watch } from 'vue-property-decorator';
import GeofenceData from './GeofenceData.vue';

@Component({
    components: { GeofenceData }
})
export default class DrawGeofence extends Vue {
    private readonly MODAL_REF = 'draw-geofence'

    drawType = 'Polygon'
    drawSource = new VectorSource({})
    options = [
        { text: 'Polígono', value: 'Polygon' },
        { text: 'Círculo', value: 'Circle' }
    ]
    drawInteraction: Draw | null = null;

    close() {
        const modal: any = this.$refs[this.MODAL_REF]
        modal.hide();
    }

    show() {
        const modal: any = this.$refs[this.MODAL_REF]
        modal.show();
    }

    saveDraw() {
        const geometry = this.drawSource.getFeatures()[0].getGeometry()
        let area;
        if (this.drawType === 'Circle') {
            area = GeofenceUtil.formatCircleGeometry(geometry as Circle);
        } else if (this.drawType === 'Polygon') {
            area = GeofenceUtil.formatPolygonGeometry(geometry as Polygon);
        }
        this.$emit('save-area', area);
        this.close();
    }

    async initMap() {
        const principalMap = mapsModule.mapService.map;
        const originalView = principalMap.getView();

        const newView = new View({
            center: originalView.getCenter(),
            zoom: originalView.getZoom(),
            rotation: originalView.getRotation(),
            minZoom: originalView.getMinZoom(),
            maxZoom: originalView.getMaxZoom()
        });

        const source = principalMap.getLayers().getArray()[5].get('source');

        const newMap = new Map({
            target: 'geofence',
            controls: defaultControls({ attribution: false }),
            view: newView,
            layers: [
                new TileLayer({
                    source: new OSM(),
                    visible: true,
                    className: 'ostm'
                }),
                VectorService.createVectorBase('devices-geofence', source),
                VectorService.createVectorBase('geofence', this.drawSource)
            ]
        });
        geofencesModule.setMap(newMap);
    }

    initDrawingInteraction() {

        if (this.drawInteraction) geofencesModule.map.removeInteraction(this.drawInteraction);

        const type = this.drawType
        this.drawInteraction = new Draw({
            source: this.drawSource,
            type: type as Type,

        });

        this.drawInteraction.on('drawend', (event) => {
            const purpleStyle = new Style({
                stroke: new Stroke({
                    color: '#6610f2',
                    width: 3
                }),
                fill: new Fill({
                    color: 'rgba(128, 0, 128, 0.1)'
                })
            });

            event.feature.setStyle(purpleStyle);
            this.drawSource.clear()
        });
        geofencesModule.map.addInteraction(this.drawInteraction);
    }

    @Watch("drawType", { immediate: true })
    onChangeType(): void {
        this.initDrawingInteraction()
    }

    
}
</script>

<style lang="sass" scoped>
    @import '@/assets/style/variables.sass'
    @import '@/assets/style/modal-styles.sass'
    svg
        stroke: $secondary
        width: auto
        height: 25px
        stroke-width: 2px
    img
        height: 35px

    ::v-deep input[type="radio"]
        display: none !important

    #geofence
        height: 60vh
</style>